import { trackEvent } from 'core-lib/utils/events';
import { getPlatform } from 'core-lib/utils/helpers';
import { getLocalProfile } from "core-lib/utils/tokenStorage";

export const getCommonEventAttr = () => {
  const obj: any = {};
  const profile: any = getLocalProfile();
  obj.category = 'Car Listing';
  obj.platform = getPlatform();
  obj.userLat = profile?.home_address?.latitude;
  obj.userLng = profile?.home_address?.longitude;
  obj.userPhone = profile?.phone_number;
  return obj;
};

export const trackBookTestDrive = (userName,phoneNumber, pincode,brand,model) =>{
  trackEvent({
    name:'car_listing_test_drive',
    defaultAttr:getCommonEventAttr(),
    attributes:{
      userName,phoneNumber,pincode,brand,model
    }
  })
}